import * as React from "react";
import { forwardRef } from "react";
const SvgTableConfig = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_321_3173)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M1.5 11.5L2.5 18.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.66187 19.0844V23.2657",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M1.76437 23.2657L2.50156 19.0844",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.085 15.5V23.129",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.989 23.129H13.2773",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.5 15.5H16.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M1 7.9896C1.34845 7.24615 2.04537 6.62661 2.85842 6.75052L4.25221 6.87444C4.83296 6.87444 5.29759 6.62663 5.76219 6.2549C6.11064 5.88318 6.34294 5.26362 6.34294 4.64408L6.22678 3.15719C6.22678 2.28984 6.69138 1.54637 7.38829 1.17465C8.08514 0.802926 9.01435 1.05075 9.5951 1.6703L10.5243 2.78546C10.8728 3.15718 11.4535 3.405 11.9181 3.405C12.4989 3.405 12.9635 3.15718 13.3119 2.78546L14.2411 1.6703C14.8219 1.05075 15.6349 0.802926 16.448 1.17465C17.1449 1.54637 17.7256 2.28984 17.6095 3.15719L17.4933 4.64408C17.4933 5.26362 17.7256 5.75927 18.0741 6.2549C18.4226 6.62663 19.0033 6.87444 19.5841 6.87444L20.9779 6.75052C21.7909 6.75052 22.4878 7.24615 22.8363 7.9896C23.1847 8.73305 22.9524 9.72433 22.3717 10.3439L21.3263 11.3351C20.9779 11.7069 20.7456 12.3264 20.7456 12.8221C20.7456 13.3177 20.9779 13.9372 21.3263 14.309L22.3717 15.3002C22.9524 15.9198 23.1847 16.7871 22.8363 17.6545C22.4878 18.3979 21.7909 19.0175 20.9779 18.8936L19.5841 18.7696C19.0033 18.7696 18.5387 19.0175 18.0741 19.3892C17.7256 19.7609 17.4933 20.3805 17.4933 21",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeMiterlimit: 10,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M2.5 18.5H8",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_321_3173" }, /* @__PURE__ */ React.createElement("rect", {
	width: 24,
	height: 24,
	fill: "currentColor"
}))));
const ForwardRef = forwardRef(SvgTableConfig);
export default ForwardRef;
